import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { toPng } from "html-to-image";
import { Download, X } from "lucide-react";
import { toast } from "sonner";

export default function ReferralPoster({ code, onClose }) {
  const [downloading, setDownloading] = useState(false);
  const shareUrl = typeof window !== "undefined" ? `${window.location.origin}/register?ref=${code}` : `/register?ref=${code}`;

  const download = async () => {
    setDownloading(true);
    try {
      const node = document.getElementById("novya-poster");
      const dataUrl = await toPng(node, { cacheBust: true, pixelRatio: 2, backgroundColor: "#FAFAFA", skipFonts: true });
      const link = document.createElement("a");
      link.download = `novya-referral-${code}.png`;
      link.href = dataUrl;
      link.click();
      toast.success("Poster downloaded");
    } catch {
      toast.error("Download failed — try again");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div
      data-testid="poster-modal"
      className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white text-novya-ink max-w-3xl w-full max-h-[92vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center px-6 py-4 border-b border-novya-border">
          <div className="font-mono text-xs tracking-[0.2em] uppercase text-novya-muted">Shareable poster</div>
          <button onClick={onClose} data-testid="poster-close-btn" className="text-novya-muted hover:text-novya-ink"><X size={20} /></button>
        </div>

        <div className="p-6">
          <div
            id="novya-poster"
            className="mx-auto"
            style={{ width: "480px", background: "#FAFAFA", padding: "40px", border: "1px solid #E4E4E7" }}
          >
            <div style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif", fontWeight: 900, fontSize: "56px", lineHeight: "0.9", letterSpacing: "-2px", color: "#0A0A0A" }}>
              Novya<span style={{ color: "#0047FF" }}>.</span>
            </div>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.25em", textTransform: "uppercase", color: "#52525B", marginTop: "8px" }}>
              Career leaps, by design
            </div>

            <div style={{ marginTop: "36px", fontFamily: "'Cabinet Grotesk', system-ui, sans-serif", fontWeight: 900, fontSize: "40px", lineHeight: "1", letterSpacing: "-1.5px", color: "#0A0A0A" }}>
              Save ₹2,000<br />on your first cohort.
            </div>

            <div style={{ marginTop: "32px", display: "flex", alignItems: "center", gap: "24px" }}>
              <div style={{ background: "#fff", padding: "14px", border: "1px solid #E4E4E7" }}>
                <QRCodeSVG value={shareUrl} size={140} bgColor="#FFFFFF" fgColor="#0A0A0A" level="M" includeMargin={false} />
              </div>
              <div>
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.25em", textTransform: "uppercase", color: "#52525B" }}>Use code</div>
                <div style={{ marginTop: "6px", fontFamily: "'JetBrains Mono', monospace", fontSize: "18px", fontWeight: 700, color: "#0047FF" }}>
                  {code}
                </div>
                <div style={{ marginTop: "16px", fontFamily: "'IBM Plex Sans', system-ui, sans-serif", fontSize: "12px", color: "#52525B", maxWidth: "160px", lineHeight: "1.4" }}>
                  Scan or type at signup — apply at checkout to get ₹2,000 off any 9-month cohort.
                </div>
              </div>
            </div>

            <div style={{ marginTop: "36px", paddingTop: "16px", borderTop: "1px solid #E4E4E7", fontFamily: "'JetBrains Mono', monospace", fontSize: "9px", letterSpacing: "0.25em", textTransform: "uppercase", color: "#52525B" }}>
              novya.io · Software Eng · AI/ML · Data Science · Product Design
            </div>
          </div>

          <div className="mt-6 flex justify-center gap-3">
            <button
              onClick={download}
              disabled={downloading}
              data-testid="poster-download-btn"
              className="inline-flex items-center gap-2 px-6 py-3 bg-novya-ink text-white font-medium hover:bg-novya-accent transition-colors disabled:opacity-50"
            >
              <Download size={16} /> {downloading ? "Preparing…" : "Download PNG"}
            </button>
          </div>
          <p className="mt-4 text-center text-xs text-novya-muted">
            Perfect for WhatsApp Status, Instagram Stories, LinkedIn posts.
          </p>
        </div>
      </div>
    </div>
  );
}
